import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
//-------------------------------------------
import UserInfo from "src/components/common/userInfo";
import Footer from "src/components/common/frame/footer";
import { useMyStore } from "src/components/main/mainStore";
import {
    MyFormData, 
    myAxios,
} from "src/components/common/functions";
import FillIn from "./fillIn";
import List from "./fleetInventory";
import FleetForm from "./fleetForm";
//-------------------------------------------
export default function Detail({
    tabTitle, 
    history, 
    path1, 
    path2, 
    path3, 
    fleet, 
    deleteFleet, 
    editFleet, 
    handleSubmit, 

    setFleetList, 
    trucksMap,
    updateDateTime
}){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const userNames = useMyStore(state => state.userNames);
    const setFleetDetails = useMyStore(state => state.setFleetDetails);
    const fleetDetails = useMyStore(state => state.fleetDetails);
    const usersMap = Object.fromEntries(userNames.data.map(user => [user.email, user.userName]))
    
    const purchases = fleetDetails[fleet.truckNumber]?.purchases ?? [];
    const conditions = fleetDetails[fleet.truckNumber]?.conditions ?? [];
    const inventory = fleetDetails[fleet.truckNumber]?.inventory ?? [];
    const lineItems = purchases.filter(pur => 
        pur.truckNumber !== "" && 
        JSON.parse(pur.truckNumber)
        .map(pur => pur.truckNumber)
        .includes(fleet.truckNumber)
    );
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const indexOfLastLineItem = currentPage * itemsPerPage;
    const indexOfFirstLineItem = indexOfLastLineItem - itemsPerPage;
    const pageNumbers = Array.from({length: Math.ceil((lineItems.length ?? 0) / itemsPerPage)}, (_, i) => (i + 1));
    
    const [inventorysPerPage, setInventorysPerPage] = useState(10);
    const [currentInventoryPage, setCurrentInventoryPage] = useState(1);
    const indexOfLastInventory = currentInventoryPage * inventorysPerPage;
    const indexOfFirstInventory = indexOfLastInventory - inventorysPerPage;
    const inventoryPageNumbers = Array.from({length: Math.ceil((inventory.length ?? 0) / inventorysPerPage)}, (_, i) => (i + 1));
    
    const [conditionsPerPage, setConditionsPerPage] = useState(10);
    const [currentConditionPage, setCurrentConditionPage] = useState(1);
    const indexOfLastCondition = currentConditionPage * conditionsPerPage;
    const indexOfFirstCondition = indexOfLastCondition - conditionsPerPage;
    const conditionPageNumbers = Array.from({length: Math.ceil((conditions.length ?? 0) / conditionsPerPage)}, (_, i) => (i + 1));
    
    //-------------------------------------------------------------------------------------
    useEffect(() => {
        if (
            path2 === "" || 
            (updateDateTime["FleetDetails"] === fleetDetails.updatedAt && fleetDetails[fleet.truckNumber])
        ) return;

        let isMounted = true;
        const getData = async () => {
            const formData = new MyFormData();
            formData.append("truckNumber", fleet.truckNumber);
            setShowLoader(true);
            try {
                const res = await myAxios("fleet/readFleet.php", formData);
                if (!isMounted) return;
                if (!res) return;

                // Merge the new data with the existing fleet data
                const updatedFleetDetails = {
                    ...fleetDetails[fleet.truckNumber], // Preserve existing data
                    inventory: res.data.inventory ?? [],
                    conditions: res.data.conditions ?? [],
                    purchases: res.data.purchases ?? [],
                };

                setFleetDetails(fleet.truckNumber, updatedFleetDetails, updateDateTime["FleetDetails"]);
            } finally {
                setShowLoader(false); // Ensure loader is disabled in all cases
            }
        };
        getData();
        return () => {
            isMounted = false;
        };
    }, [updateDateTime, fleet.truckNumber, setFleetDetails, setShowLoader, fleetDetails, path2, fleetDetails[fleet.truckNumber]]);
    //-------------------------------------------------------------------------------------
    return(
    <div className = "border rounded">
        <div className = "cssSeperateWhenWide pl-2 mb-3">
            <div className = "flex-grow-1 maxWidth-50 pr-2">
                <table className = "table table-fixed">
                    <tbody className = "noTableTopBorder">
                        <tr>
                            <th>License #</th>
                            <td>{fleet.licenseNumber}</td>
                        </tr>
                        <tr>
                            <th>VIN</th>
                            <td>{fleet.vin}</td>
                        </tr>
                        <tr>
                            <th>Year</th>
                            <td>{fleet.year}</td>
                        </tr>
                        <tr>
                            <th>Make</th>
                            <td>{fleet.make}</td>
                        </tr>
                        <tr>
                            <th>Model</th>
                            <td>{fleet.model}</td>
                        </tr>
                        {fleet.creatorEmail?
                        <tr>
                            <th>Creator</th>
                            <td>
                                <UserInfo 
                                    name = {fleet.creator}
                                    email = {fleet.creatorEmail}
                                />
                                <span className = "ml-3">
                                    {fleet.dateCreated}
                                </span>
                            </td>
                        </tr>
                        :<></>}
                        {fleet.updaterEmail?
                        <tr>
                            <th>Updater</th>
                            <td>
                                <UserInfo 
                                    name = {fleet.updater}
                                    email = {fleet.updaterEmail}
                                />
                                <span className = "ml-3">
                                    {fleet.dateUpdated}
                                </span>
                            </td>
                        </tr>
                        :null}
                    </tbody>
                </table>
                <details
                    id = "relatedExpence"
                    className = "position-relative mb-2"
                    onToggle = {e => {
                        if(lineItems.length){
                            if(e.currentTarget.open){
                                e.currentTarget.classList.add("pb10");
                           }else{
                               e.currentTarget.classList.remove("pb10");
                           }
                        }
                    }}
                >
                    <summary>
                        <span className = "mr-2 font-weight-bold">
                            Related Expence
                        </span>
                        <span>
                            {lineItems.length}
                        </span>
                    </summary>
                    <ul>
                        {lineItems.slice(indexOfFirstLineItem, indexOfLastLineItem).map(
                            (pur, pi) => 
                            <li key = {pi} className = "mt-1">
                                <Link
                                    to = {`/Purchases/${pur.poNumber}`}
                                >
                                    {pur.poNumber} &mdash; ${pur.total} {
                                        JSON.parse(pur.truckNumber).length > 1?
                                        <span>
                                            (include other fleets)
                                        </span>:null
                                    }
                                </Link>
                            </li>
                        )}
                    </ul>
                    {lineItems.length?
                    <Footer
                        pageSelectId = {"relatedExpence"}
                        length = {lineItems.length}
                        pageNumbers = {pageNumbers}
    
                        currentPage = {currentPage}
                        setCurrentPage = {setCurrentPage}
                        itemsPerPage = {itemsPerPage}
                        setItemsPerPage = {setItemsPerPage}

                        parentId = {"relatedExpence"}
                    />
                    :null}
                </details>
                <details
                    id = "inventory"
                    className = "position-relative mb-2"
                    onToggle = {e => {
                        if(lineItems.length){
                            if(e.currentTarget.open){
                                e.currentTarget.classList.add("pb10");
                           }else{
                               e.currentTarget.classList.remove("pb10");
                           }
                        }
                    }}
                >
                    <summary>
                        <span className = "mr-2 font-weight-bold">
                            Inventory
                        </span>
                        <span>{inventory.length}</span>
                    </summary>
                    <ul>
                        {inventory.slice(indexOfFirstInventory, indexOfLastInventory).map((inv, pi) => 
                        <li key = {pi} className = "mb-3">
                            <ul>
                                <div className = "font-weight-bold text-success">{inv.submitDate} {inv.submitTime}</div>
                                <div className = "font-weight-bold text-dark">
                                    {usersMap[inv.labor]}
                                </div>
                                {inv.content.filter(c => c.qty !== window.parseInt(c.value)).map((c, ci) => 
                                <li key = {ci}>
                                    {c.title}
                                    &nbsp;&nbsp;
                                    <span className = {"font-weight-bold " + (c.qty < window.parseInt(c.value)?"text-success": "text-danger")}>
                                    {c.qty === window.parseInt(c.value)?
                                        <></>
                                        :
                                        (
                                            c.qty < window.parseInt(c.value)?
                                            <>+ {(window.parseInt(c.value) - c.qty)}</>
                                            :
                                            <>{window.parseInt(c.value) - c.qty}</>
                                        )
                                    }
                                    </span>
                                </li>)}
                            </ul>
                            <div className = "mt-2">
                                See<Link className = "font-weight-bold ml-2"
                                    to = {`/Projects/${inv.projectHashKey}/WorkInstructions/${inv.workInstructionHashKey}/WorkLogs/${inv.workLogHashKey}/${inv.formName}`}
                                >Detail</Link>
                            </div>
                            <FillIn
                                index = {pi}
                                className = {"mt-2"}
                                defaultValue = {inv.comments}
                                defaultChecked = {inv.completed}
                                handleNotes = {async value => {
                                    const formData = new MyFormData();
                                    formData.append("workLogHashKey", inv.workLogHashKey);
                                    formData.append("key", inv.formKey);
                                    formData.append("comments", value);
                                    //---------------------------------------------------------------------
                                    setShowLoader(true);
                                    const res = await myAxios("fleet/inventoryComments.php", formData);
                                    setShowLoader(false);
                                    if(!res) return;
                                    //---------------------------------------------------------------------
                                    setFleetDetails(fleet.truckNumber, {conditions, purchases, 
                                        inventory: inventory.map(i => 
                                        i.workLogHashKey === inv.workLogHashKey &&
                                        i.formName === inv.formName?
                                        {...i, comments: value}
                                        :i
                                    )});
                                }}
                                handleHandled = {async e => {
                                    const checked = e.currentTarget.checked;
                                    const formData = new MyFormData();
                                    formData.append("workLogHashKey", inv.workLogHashKey);
                                    formData.append("key", inv.formKey);
                                    formData.append("completed", checked);
                                    //---------------------------------------------------------------------
                                    setShowLoader(true);
                                    const res = await myAxios("fleet/inventoryCompleted.php", formData);
                                    setShowLoader(false);
                                    if(!res) return;
                                    //---------------------------------------------------------------------
                                    setFleetDetails(fleet.truckNumber, {conditions, purchases, 
                                        inventory: inventory.map(i => 
                                        i.workLogHashKey === inv.workLogHashKey &&
                                        i.formName === inv.formName?
                                        {...i, completed: checked?"true":"false"}
                                        :i
                                    )});
                                }}
                            />
                        </li>)}
                    </ul>
                    {inventory.length?
                    <Footer
                        pageSelectId = {"inventory"}
                        length = {inventory.length}
                        pageNumbers = {inventoryPageNumbers}
    
                        currentPage = {currentInventoryPage}
                        setCurrentPage = {setCurrentInventoryPage}
                        itemsPerPage = {inventorysPerPage}
                        setItemsPerPage = {setInventorysPerPage}

                        parentId = {"inventory"}
                    />
                    :null}
                </details>
                <details
                    id = "conditions"
                    className = "position-relative mb-2"
                    onToggle = {e => {
                        if(lineItems.length){
                            if(e.currentTarget.open){
                                e.currentTarget.classList.add("pb10");
                        }else{
                            e.currentTarget.classList.remove("pb10");
                        }
                        }
                    }}
                >
                    <summary>
                        <span className = "mr-2 font-weight-bold">
                            Conditions
                        </span>
                        <span>{conditions.length}</span>
                    </summary>
                    <ul>
                        {conditions.slice(indexOfFirstCondition, indexOfLastCondition).map((p, pi) => 
                        <li key = {pi}>
                            <Link to = {`/Forms/${p.formHashKey}`}>
                                <span
                                    className = "mr-2 p-1 rounded"
                                    style = {{
                                        backgroundColor: 
                                        JSON.parse(p.formContent)["Is the vehicle still safe to drive?"] === "No"?
                                        "lightsalmon":"yellow"
                                    }}>
                                    {JSON.parse(p.formContent)["Date of Incident"]}
                                    &nbsp;&nbsp;
                                    {JSON.parse(p.formContent)["Equipment Affected"]}
                                </span>
                                {
                                p.dateCompleted?
                                <span>✅</span>
                                :
                                null
                                }
                            </Link>
                        </li>)}
                    </ul>
                    {conditions.length?
                    <Footer
                        pageSelectId = {"conditions"}
                        length = {conditions.length}
                        pageNumbers = {conditionPageNumbers}
    
                        currentPage = {currentConditionPage}
                        setCurrentPage = {setCurrentConditionPage}
                        itemsPerPage = {conditionsPerPage}
                        setItemsPerPage = {setConditionsPerPage}

                        parentId = {"conditions"}
                    />
                    :null}
                </details>
            </div>
            <div className = "d-flex flex-column flex-grow-1 maxWidth-50 pr-2">
                <fieldset className = "border rounded flex-grow-1 mx-2">
                    <legend className = "font-weight-bold w-auto px-2">Background</legend>
                    <span className = "cssNotes">{fleet.background}</span>
                </fieldset>
            </div>
        </div>
        <div className = "text-right p-2">
            <button
                type = "button"
                className = "btn btn-info"
                onClick = {() => {
                    history.push(`/${path1}/${fleet.truckNumber}/List`);
                }}
            >Inventory</button>
            {path3 === "List"?
            <List
                trucksMap = {trucksMap}
                setFleetList = {setFleetList}
                tabTitle = {tabTitle}
                closeIt = {() => history.push(`/${path1}/${fleet.truckNumber}`)}
                history = {history}
                data = {fleet.inventory}
            />:<></>}
            <button
                type = "button"
                className = "btn btn-primary ml-3"
                onClick = {editFleet}
            >
                Edit
            </button>
            {path3 === "Edit"?
            <FleetForm
                keyword = "Edit"
                handleSubmit = {handleSubmit}
                closeIt = {() => history.push(`/${path1}/${path2}`)}
                shoulDisable = {true}
                postUrl = "fleet/updateFleet.php"
                users = {userNames.data}
                {...fleet}
            />
            :null}
            <button
                type = "button"
                className = "btn btn-danger ml-3"
                onClick = {deleteFleet}
                id = {fleet.truckNumber}
            >
                Delete
            </button>
        </div>
    </div>
    )
}